import React, { useState } from "react";
import { Button, Menu, Dropdown, Modal } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { usePermissions } from "lib/permissionHook";
import { deleteTaxManagement } from "redux/actions";
import EditTaxManagement from "../EditTaxManagement";
import ShowTaxManagement from "../ShowTaxManagement";
import ModalCloseConfirm from "lib/components/ModalCloseConfirm";
import { AiOutlineClose } from "react-icons/ai";
import ModalDeleteConfirm from "lib/components/ModalDeleteConfirm";

const MODULE_NAME = "SHIPPING SUPPLIER";

function TaxManagementAction({ data }) {
  const { messages } = useIntl();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isShowModalVisible, setIsShowModalVisible] = useState(false);

  const { profile } = useSelector(({ profile }) => profile);

  const permission = usePermissions(MODULE_NAME, profile);

  const dispatch = useDispatch();

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const showShowModal = () => {
    setIsShowModalVisible(true);
  };

  const handleShowOk = () => {
    setIsShowModalVisible(false);
  };

  const handleShowCancel = () => {
    setIsShowModalVisible(false);
  };
  const handleDelete = () => {
    dispatch(deleteTaxManagement(data._id));
  };

  const menu = (
    <Menu>
      <Menu.Item style={{ fontSize: 14 }} onClick={showShowModal}>
        View
      </Menu.Item>
      <Menu.Item
        style={{ fontSize: 14 }}
        onClick={showModal}
        disabled={permission && !permission.update && !profile.isSuperAdmin}
      >
        Edit
      </Menu.Item>
      <Menu.Item
        style={{ fontSize: 14 }}
        disabled={permission && !permission.delete && !profile.isSuperAdmin}
      >
        {permission && !permission.delete && !profile.isSuperAdmin ? (
          "Delete"
        ) : (
          <ModalDeleteConfirm handleDelete={handleDelete} />
        )}
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Dropdown overlay={menu} trigger={["click"]}>
        <Button type="circle">
          <MoreOutlined />
        </Button>
      </Dropdown>

      <Modal
        title={messages["admin.editTaxManagement"]}
        visible={isModalVisible}
        onOk={handleOk}
        footer={false}
        width={800}
        maskClosable={false}
        destroyOnClose={true}
        closeIcon={<ModalCloseConfirm onCancel={handleCancel} />}
      >
        <EditTaxManagement data={data} closeModel={handleCancel} />
      </Modal>

      <Modal
        title={messages["admin.showTaxManagement"]}
        visible={isShowModalVisible}
        onOk={handleShowOk}
        footer={false}
        maskClosable={false}
        destroyOnClose={true}
        closeIcon={<AiOutlineClose onClick={handleShowCancel} />}
      >
        <ShowTaxManagement taxManagement={data} />
      </Modal>
    </>
  );
}

export default TaxManagementAction;

TaxManagementAction.propTypes = {
  data: PropTypes.object,
};
